<template>
    <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="md-layout md-gutter">
                <div class="md-layout-item">
                    <div class="card-icon">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'bars']" />
                    </div>
                    <h4 class="title">Liste des interventions planifiées sans contrat actif</h4>
                </div>
            </div>
        </md-card-header>
        <md-card-content>
	        <div class="flex items-center justify-between">
		        <div class="flex items-center space-x-4 divide-x-2">
			        <span class="font-medium">{{ `Total : ${pagination.total} interventions` }}</span>
			        <span class="font-medium pl-3">{{ selectedInterventions.length > 0 ? `${selectedInterventions.length} intervention(s) sélectionnée(s)` : 'Aucune intervention sélectionnée' }}</span>
			        <md-button class="md-danger md-icon-button" :disabled="selectedInterventions.length === 0 || loading" @click="deleteInterventions">
				        <span class="font-medium leading-none">Supprimer</span>
			        </md-button>
		        </div>
		        <div style="min-width: 200px;">
			        <div class="md-multiselect">
				        <label>Éléments à afficher</label>
				        <multiselect v-model="pagination.perPage"
				                     :options="pagination.perPageOptions"
				                     :searchable="false"
				                     :show-labels="false"
				                     :allow-empty="false">
					        <template slot="noOptions">La liste est vide</template>
					        <template slot="noResult">Aucun élement correspondant</template>
				        </multiselect>
			        </div>
		        </div>
	        </div>
            <div class="relative" style="min-height: 150px;">
	            <md-table class="paginated-table no-actions" :value="interventions" table-header-color="blue" @md-selected="checkInterventionRow">
		            <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="multiple">
			            <md-table-cell md-label="Contrat">
				            <span class="font-medium mr-1">Numéro :</span>
				            <span>{{ item.contract_number }}</span>
			            </md-table-cell>
			            <md-table-cell md-label="Intervention" style="max-width: 200px; width: 200px;">
				            <div>
					            <span class="font-medium mr-1">Planifiée le :</span>
					            <span>{{ $moment(item.start_date).format('DD/MM/YYYY') }}</span>
				            </div>
				            <div>
					            <span class="font-medium mr-1">État :</span>
					            <span>{{ item.status_name }}</span>
				            </div>
			            </md-table-cell>
			            <md-table-cell md-label="Site - Client" style="max-width: 550px; width: 550px;">
				            <div class="font-medium">{{ item.site_name }}</div>
				            <div class="text-xs">{{ item.client_name }}</div>
			            </md-table-cell>
		            </md-table-row>
		            <md-table-empty-state v-if="!loading"
		                                  md-label="Pas d'interventions trouvées"
		                                  md-description="Essayez une recherche différente">
		            </md-table-empty-state>
	            </md-table>
	            <div v-if="loading" class="loader-overlay opacity-100 absolute z-50 w-full h-full">
		            <div class="h-full w-full flex items-center justify-center">
			            <md-progress-spinner class="md-white" md-mode="indeterminate"
			                                 :md-diameter="50" :md-stroke="4"></md-progress-spinner>
		            </div>
	            </div>
            </div>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
            <p class="card-category">
                Affichage des éléments {{ from + 1 }} à {{ to }} sur {{ pagination.total }} éléments
            </p>
            <pagination
                class="pagination-no-border pagination-info"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.total"
                @input="getInterventions"
            >
            </pagination>
        </md-card-actions>
    </md-card>
</template>

<script>
// Components
import { Pagination } from '../../../components'

// Mixins
import routerMixin from "../../../mixins/router-mixin";
import tablePaginationMixin from "../../../mixins/table-pagination-mixin";

export default {
    name: "InterventionWithoutContract",
    components: {
        Pagination
    },
    mixins: [routerMixin, tablePaginationMixin],
    props: {
        active: Boolean,
    },
    data() {
        return {
            interventions: [],
	        selectedInterventions:[],
            pagination: {
                perPage: 100,
                perPageOptions: [100, 200, 300],
            },
	        loading: true
        }
    },
    methods: {
        async getInterventions() {
			this.loading = true
            const { data } = await this.$store.dispatch('stats/getInterventionWithoutContract', {
                page: this.pagination.currentPage,
                perPage: this.pagination.perPage,
                search: this.searchQuery,
            })
            this.interventions = data.data
            this.pagination.total = data.total
	        this.loading = false
        },
	    checkInterventionRow(items) {
			this.selectedInterventions = items.map(intervention => intervention.id)
	    },
	    async deleteInterventions() {
			this.loading = true
		    try {
				await this.$store.dispatch('stats/deleteInterventions', {
					interventions: this.selectedInterventions
				})
			    await this.$store.dispatch('alerts/success', 'Intervention(s) supprimée(s)')
			    await this.getInterventions()
		    } catch (e) {}
	    }
    },
    mounted() {
        if (this.active) {
            this.getInterventions()
        }
    },
	beforeDestroy() {
		this.interventions = []
	},
	watch: {
        active: function (newVal, oldVal) {
            if (newVal) {
                this.getInterventions()
            }
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep {
	.md-table-head {
		&.md-table-cell-selection {
			max-width: 30px;

			.md-table-head-label {
				padding: 0;
			}
		}
	}
	.md-table-row {
		.md-table-cell-selection {
			max-width: 30px;

			.md-checkbox {
				width: auto !important;

				.md-checkbox-container {
					width: 18px;
					min-width: 18px;
					height: 18px;
				}
			}
		}
	}
}
</style>
